/**
 * Troop 936 calendar page — embeds Google Calendar from site settings.
 */
(function () {
  'use strict';

  async function init() {
    const ok = await window.Troop936MemberGuard?.guardMember?.();
    if (ok === false) return;

    await window.Troop936Content?.applySiteSettings?.();
    const settings = await window.Troop936Content.loadSettings();
    const url = settings.google_calendar_embed_url;
    const container = document.getElementById('calendar-embed');
    if (!container || !url) return;

    container.innerHTML = `
      <iframe
        src="${url.replace(/"/g, '&quot;')}"
        title="Troop 936 Google Calendar"
        class="calendar-iframe"
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade">
      </iframe>
    `;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

export {};
